/**
 * Tailwind breakpoints in px — the single JS source for them. The theme in
 * `app/assets/css/tailwind.css` keeps Tailwind's defaults (no
 * `--breakpoint-*` overrides); change both together.
 */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const

export type Breakpoint = keyof typeof BREAKPOINTS

/** Media query matching the Tailwind `<breakpoint>:` variant, e.g. `md:`. */
export const minWidthQuery = (breakpoint: Breakpoint) =>
  `(min-width: ${BREAKPOINTS[breakpoint]}px)`
